import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';

/**
 * Processes Page
 * Lists API groups and provides navigation to API documentation
 */
const Processes = () => {
  const sections = [
    {
      id: 'overview',
      title: 'API Processes Overview',
      content: `Our platform exposes APIs through two main groups:

- **Customer Portal APIs**: Authenticated APIs for customer operations, tenant management, and resource management
- **Public APIs**: Public-facing APIs for bot operations, knowledge management, and integrations

All APIs are documented with technical details, request/response examples, and links to interactive API documentation.`
    },
    {
      id: 'customer-portal-apis',
      title: 'Customer Portal APIs',
      content: `The Customer Portal APIs provide authenticated access to:

- Resource management (bots, knowledge bases, etc.)
- Tenant and user management
- Knowledge management operations
- Session and analytics
- Cost tracking and billing
- Support ticket management
- Security and permissions

[View all Customer Portal APIs →](/architecture/processes/customer-portal)`
    },
    {
      id: 'public-apis',
      title: 'Public APIs',
      content: `The Public APIs enable integrations and public access to:

- Bot operations (sessions, conversations)
- Bot management
- Knowledge management and search
- Resource management
- Agent actions and thoughts
- SDK serving
- Email webhooks
- Resale operations

[View all Public APIs →](/architecture/processes/public)`
    },
    {
      id: 'api-documentation',
      title: 'Interactive API Documentation',
      content: `For interactive API documentation with:

- Try-it-out functionality
- Request/response examples
- Authentication testing
- Schema definitions

Visit our [API Documentation](/api-docs) page.`
    },
    {
      id: 'authentication',
      title: 'Authentication',
      content: `### Customer Portal APIs
- **JWT Tokens**: Authenticate using Entra External ID tokens
- **Tenant Scoping**: All operations are scoped to your tenant
- **Role-Based Access**: Permissions based on user roles

### Public APIs
- **API Keys**: Use API keys for authenticated requests
- **Public Access**: Some endpoints are publicly accessible
- **Resource-Specific**: Some operations require resource-specific authentication`
    }
  ];

  return (
    <ArchitectureLayout
      title="Processes"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default Processes;

